import { gql } from '@apollo/client';

export const GET_TOKEN = gql`
  query GetToken($getTokenRequest: GetTokenRequest!) {
    GetToken(getTokenRequest: $getTokenRequest) {
      access_token
    }
  }
`;

export const GET_PROFILE = gql`
  query GetProfile {
    GetProfile {
      sub
      exp
      iat
    }
  }
`;

export const GET_KIBANA_TOKEN = gql`
  query getKibanaToken {
    getKibanaToken {
      key
      exp
      sub
      space
      timestamp
    }
  }
`;

export const GET_KIBANA_DASHBOARDS = gql`
  query getKibanaDashboards {
    getKibanaDashboards {
      data {
        id
        title
      }
    }
  }
`;
